module.exports = __webpack_public_path__ + "img/2018-04-29.96102180.jpg";